module.exports = __webpack_public_path__ + "img/logo-w.7e43d3e1.png";